import { breakpoints } from './breakpoints';
import { colors } from './colors';
import { radii } from './radii';
import { shadows } from './shadows';
import { sizes } from './sizes';
import { space } from './space';
import { typography } from './typography';
import { zIndices } from './zIndices';

export const foundations = {
  breakpoints,
  colors,
  radii,
  sizes,
  shadows,
  space,
  ...typography,
  zIndices,
};
